import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss']
})
export class DefaultFooterComponent implements OnInit {
  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
